/**
 * @param id search param to delete, default is "id"
 * @description delete search param so modal that depends on it closes, only works in app router
 */
export const closeAppModal = (id = 'id') => {
  const params = new URLSearchParams(window.location.search);
  if (params.has(id)) {
    params.delete(id);

    window.history.pushState(
      null,
      '',
      `${window.location.pathname}${params.size ? `?${params.toString()}` : ''}`
    );
  }
};

/**
 * @param id search param to add, default is "id"
 * @param value value of search param, default is "new"
 * @description add search param so modal that depends on it opens, only works in app router
 */
export const openAppModal = (id = 'id', value: string | number = 'new') => {
  const params = new URLSearchParams(window.location.search);
  params.set(id, value.toString());

  window.history.pushState(null, '', `?${params.toString()}`);
};
